import { isNotNil } from 'rambda';
import { isNotEmpty } from 'rambda/immutable';
import { Fragment, type ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import SuccessIndicator from '@/components/settings/debug/success-indicator';
import cn from '@/utils/merge-class-names';

export interface InfoData {
  label: string | (() => string);
  key: string;
  value: ReactNode;
  suffix?: ReactNode;
}

interface Props {
  className?: string;
  data: InfoData[];
}

export default function InfoTable({ data, className }: Props) {
  const { t } = useTranslation();

  return (
    <dl className={cn('border border-metal-100 rounded', className)}>
      {data
        .filter(({ value }) => (isNotNil(value) && typeof value === 'boolean' ? true : isNotEmpty(value)))
        .map(({ label, key, value, suffix }) => (
          <Fragment key={key}>
            <dt className='text-body2 text-metal-700 px-2 py-1.5 border-b border-e border-metal-100 bg-metal-50 font-bold text-nowrap last-of-type:border-b-0'>
              {typeof label === 'function' ? label() : t(label)}
            </dt>
            <dd className='text-body2 text-metal-700 px-2 py-1.5 border-b last-of-type:border-0 border-metal-100 font-mono inline-flex flex-col xxs:flex-row justify-between xxs:items-center'>
              {typeof value === 'boolean' ? <SuccessIndicator success={value} /> : value}

              {suffix}
            </dd>
          </Fragment>
        ))}
    </dl>
  );
}
